export const QUERY_KEYS = {
    profile: 'profile',
    pricing: 'pricing',
}
